import React from "react";
import { useTranslation } from "react-i18next";
import Checkbox from "../../../../../components/Checkbox";
import Button from "../../../../../components/Button";
import { VALIDATION_FIELD_MAPPING } from "../../../../../utils/appConstant";
import { formatDollarAmount } from "../../../../../utils/methods";

interface TableHeaderSectionProps {
  total: number;
  kpis: {
    matched: string;
    unmatched: string;
    ratio: string;
  };
  selectAll: boolean;
  onSelectAll: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddNote: () => void;
  bulkNoteDisabled?: boolean;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({
  total,
  kpis,
  selectAll,
  onSelectAll,
  onAddNote,
  bulkNoteDisabled
}) => {
  const { t } = useTranslation();

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">

        {/* ---- Row 1: Title + KPIs ---- */}
        <div className="col-sm-12 px-3 py-4 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-calendar-todo-line ri-22px"></i>
            <h5 className="mx-3 my-0">
              {t('reconciliation.payout.list.pageTexts.table.title')} ({total})
            </h5>
          </div>

          <div className="d-flex align-items-center">
            <span className="me-1 fw-semibold">{t('reconciliation.payout.list.pageTexts.table.kpis.matched')}:</span>
            <span className="badge bg-success me-2">
              {kpis.matched ? formatDollarAmount(kpis.matched) : '$0.00'}
            </span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t('reconciliation.payout.list.pageTexts.table.kpis.unmatched')}:</span>
            <span className="badge bg-danger me-2">
              {kpis.unmatched ? formatDollarAmount(kpis.unmatched) : '$0.00'}
            </span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t('reconciliation.payout.list.pageTexts.table.kpis.ratio')}:</span>
            <span className="badge bg-secondary me-2">
              {kpis.ratio ? `${kpis.ratio}%` : '0%'}
            </span>
          </div>
        </div>

        {/* ---- Row 2: Select All + Add Note ---- */}
        {/* <div className="col-sm-12 px-3 py-3 d-flex align-items-center justify-content-between">
          <div className="row align-items-center">
            <div className="form-floating form-floating-outline">
              <Checkbox
                variant="primary"
                className="d-checkbox mb-0"
                checked={selectAll}
                label={t('reconciliation.payout.list.pageTexts.table.selectAll')}
                name={VALIDATION_FIELD_MAPPING.select}
                onChange={onSelectAll}
              />
            </div>
          </div>

          <div>
            <Button
              className="btn btn-sm btn-primary waves-effect waves-light"
              text={t('reconciliation.payout.list.pageTexts.table.addNote')}
              icon={<i className="ri-sticky-note-add-line me-1"></i>}
              onClick={onAddNote}
              disabled={bulkNoteDisabled}
            />
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default TableHeaderSection;
